<template>
    <v-navigation-drawer v-if="!isMobile" app right permanent width="300" color="surface" class="company-panel">
        <agenda-panel-body v-if="coachId" :coach-id="coachId" readonly />
        <gym-alerts :stats="stats" />
    </v-navigation-drawer>

    <div v-else class="company-panel--mobile">
        <agenda-panel-body v-if="coachId" :coach-id="coachId" readonly />
        <gym-alerts :stats="stats" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import { fetchCompanyStats } from "@/utils/CompanyStats";
import AgendaPanelBody from "@/components/coach/agenda/AgendaPanelBody";
import GymAlerts from "@/components/company/home/GymAlerts";

export default {
    name: "CompanyHomePanel",
    components: { AgendaPanelBody, GymAlerts },
    data() {
        return {
            stats: null,
        }
    },
    computed: {
        ...mapState(['libraryCoach']),
        coachId(vm = this) {
            return vm.libraryCoach?.id || null
        },
        companyId(vm = this) {
            return vm.currentUser?.uid || null
        },
    },
    async mounted() {
        const vm = this
        vm.stats = await fetchCompanyStats(vm.companyId)
    },
}
</script>

<style scoped>
.company-panel ::v-deep .v-navigation-drawer__border {
    width: 2px !important;
    background-color: var(--v-outline-base) !important;
}

.company-panel--mobile {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 14px;
    overflow: hidden;
    margin-top: 24px;
}
</style>
